import React from 'react';
import classNames from 'classnames';

import css from './Switcher.module.css';

/**
 * Switcher icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} SVG icon
 */
const Switcher = props => {
  const { rootClassName, className, isActive, onSwitcherChange} = props;
  const classes = classNames(rootClassName || css.root, className, {[css.rootActive]: isActive});

  return (
    <div className={classes} onClick={onSwitcherChange}>
      <div className={css.circle} />
    </div>
  );
};

export default Switcher;
